<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { title = undefined, children, ...rest }: Props = $props();

	interface Props {
		fill?: string;
		class?: string;
		width?: string | number;
		height?: string | number;
		viewBox?: string;
		title?: string | undefined;
		children?: import('svelte').Snippet;
	}
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	width="24"
	height="24"
	class={twMerge('h-6 w-6', rest.class)}
	{...rest}
>
	{#if title}
		<title>{title}</title>
	{/if}
	{@render children?.()}
</svg>
